import { render } from "./Lihat.vue?vue&type=template&id=7c4848ff&scoped=true"
import script from "./Lihat.vue?vue&type=script&lang=js"
export * from "./Lihat.vue?vue&type=script&lang=js"

import "./Lihat.vue?vue&type=style&index=0&id=7c4848ff&lang=scss&scoped=true"

import exportComponent from "/mnt/e/med/Project/primitive/whouse-disperindag/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4848ff"]])

export default __exports__